// extracted by mini-css-extract-plugin
export var active = "_34-7";
export var container = "_34-0";
export var evenWidth = "_34-4";
export var large = "_34-5";
export var outlet = "_34-8";
export var slide = "_34-2";
export var small = "_34-6";
export var tab = "_34-3";
export var tabs = "_34-1";